import React, {FC, useMemo} from "react";
import {Form} from "react-bootstrap";
import {AdminRolesLabels, AdminsRoles} from "enums/AdminsRoles";

interface RoleSelectProps {
    value: AdminsRoles;
    onChange: (role: AdminsRoles) => void;
    disabled?: boolean;
    allowNone?: boolean;
}

export const RoleSelect: FC<RoleSelectProps> = ({value, onChange, disabled = false, allowNone = false}) => {
    const roleOptions = useMemo(() => {
        const roles = Object.values(AdminsRoles);
        return allowNone ? roles : roles.filter(r => r !== AdminsRoles.None);
    }, [allowNone]);

    return (
        <Form.Select
            value={value}
            onChange={e => onChange(e.target.value as AdminsRoles)}
            disabled={disabled}
        >
            {!allowNone && <option value={AdminsRoles.None} disabled>Роль</option>}
            {roleOptions.map(r => (
                <option key={r} value={r}>{AdminRolesLabels[r]}</option>
            ))}
        </Form.Select>
    );
};

